import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';

import { isGeoMotionVideo } from '../../../modules/checkDeployEnv';

const DashBoardButton = ({ history, deployEnv }) => {
  if (isGeoMotionVideo(deployEnv)) {
    return (
      <>
        <Button onClick={() => history.push(`/dashboard`)}>DashBoard</Button>
        <p />
      </>
    );
  }
  return '';
};

DashBoardButton.propTypes = {
  deployEnv: PropTypes.string.isRequired,
  history: PropTypes.object.isRequired
};

export default DashBoardButton;
